export default __webpack_public_path__ + "77223adece03fb8f4e4a4e07b0054b4c.svg";